// 发送邮箱验证
const sendEmail = 'sendEmail';
// 发送手机验证
const sendPhone = 'sendSMS';
// 上传图片接口
const upLoadImg = `picture/uploadAbsolutelyPictures`;

// 通过国家id获取店铺列表
const shopList = 'websiteshop/shopList';




export {
  sendEmail,
  sendPhone,
  upLoadImg,
  shopList
}